module.exports = __webpack_public_path__ + "img/arm-grabber.2615bef6.png";